export default __webpack_public_path__ + "static/ai-group-a01e87543bc36661343313c7132c9122.webp";